import PropTypes from 'prop-types';
import { useDispatch } from 'app/lib/hooks';
import { doToggleConnectionStatusModal } from 'app/store/snowflakeConfiguration';
import { LinkButton } from 'app/components/core/LinkButton';

export function OpenSnowflakeConnectionStatusButton({ children, ...props }) {
    const dispatch = useDispatch();
    const onToggleConnectionStatusModal = (value) => dispatch(doToggleConnectionStatusModal(value));

    return (
        <LinkButton onClick={() => onToggleConnectionStatusModal(true)} {...props}>
            {children}
        </LinkButton>
    );
}

OpenSnowflakeConnectionStatusButton.propTypes = {
    children: PropTypes.node.isRequired
};
